<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel flush">
				<div class="heading">Sensor Failures for {{asset.asset_name}}</div>
				<div class="content">
					<ng-template ngbModalContainer></ng-template>
					<div *ngIf="pageLogs === undefined" class="text-center pt-3 pb-3">
						<div class="logo-spin light"></div>
						Loading sensor failures...
					</div>
					<div *ngIf="pageLogs && pageLogs.length === 0" class="pt-3 pb-3">
						No failures recorded
					</div>
					<ng-container *ngIf="pageLogs && pageLogs.length > 0">
						<table class="table-comm-failures">
							<thead>
								<tr>
									<th>Timestamp</th>
									<th>Device</th>
									<th>Device ID</th>
									<th>Type</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody *ngFor="let log of pageLogs">
								<tr>
									<td>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</td>
									<td>{{log.device_name}}</td>
									<td>{{log.device}}</td>
									<td>{{log.source}}</td>
									<td>{{log.status}}</td>
								</tr>
							</tbody>
						</table>
						<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
							[rotate]="true"></ngb-pagination>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>